////////LIBRARY/////////
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { isEqual, isNull } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Button from '../../../../components/Ui/Buttons'
import Modals from '../../../../components/Modals'
import theme from '../../../../theme/theme'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
import CalendarInputInline from '../../../../components/CalendarInputInline/CalendarInputInline'
import ArticleDatePicker from '../../../ArticleLifeManager/Components/DatePicker/ArticleDatePicker'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModifyScheduleDeactivateActionWrapper = styled.div`
	& p {
		margin: 0px;
	}
	& i {
		font-size: ${(props) => props.theme.font.fxs};
		margin: 0px;
	}
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 60px;
	text-align: center;
	& > * {
		margin-bottom: 30px !important;
		display: block;
	}
`
const ModalScheduleDeactivateActionCheckboxWrapper = styled.div`
	display: flex;
	flex-direction: column;
	text-align: justify;
	& > div {
		margin: 6px 0px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	& > div * {
		vertical-align: middle;
	}
	& span {
		margin: 0px 15px;
	}
	& input[type='checkbox'] {
		margin-right: 10px;
	}
`
const ModalScheduleDeactivateActionRadioWrapper = styled.div`
	display: grid;
	grid-row-gap: 10px;
	text-align: justify;
	& > div {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
	}
	& input[type='radio'] {
		margin-right: 10px;
	}
`
const ModalScheduleDeactivateActionRadioText = styled.div`
	& * {
		display: inline-block;
		margin-bottom: 10px;
	}
`
const SpanDateDeactivation = styled.span`
	color: ${(props) => props.theme.colors.primary};
`
const ModalScheduleDeactivateActionReapproWrapper = styled.div`
	align-items: center;
	& > div > div {
		display: flex;
		flex-direction: row;
	}
	& > div > div > *:first-child {
		margin-right: 15px;
	}
	& span {
		margin-right: 15px;
	}
	& .p_resultDateReappro {
		display: block;
	}
`
/////////STYLED/////////
// [88]_a): LAUNCH PROGRESSIVE DESACTIVATION

const ModifyScheduleDeactivateAction = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [canValidate, setCanValidate] = useState(false) // Use to lock validation button

	const [scheduledDeactivationState, setScheduledDeactivationState] = useState(props.updateMode ? true : false) // By default it is launched immediatly
	const [showScheduledDateModalHandler, setShowScheduledDateModalHandler] = useState(false)

	const [currentDateDeactivation, setCurrentDateDeactivation] = useState(moment(new Date()).add(1, 'days').toDate()) // Date displayed in modal
	const [dateDeactivation, setDateDeactivation] = useState(moment(new Date()).add(1, 'days').toDate()) // Date used in back call

	const [reapproChoice, setReapproChoice] = useState(0) // No radio selected by default
	const [currentDateReappro, setCurrentDateReappro] = useState(null) // Date displayed in modal
	const [dateReappro, setDateReappro] = useState(null) // Date displayed in modal
	const [showReapproDateModalHandler, setShowReapproDateModalHandler] = useState(false)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleScheduleDeactivate = () => {
		// Prepping object to validate
		let body = {
			dateToSet: scheduledDeactivationState ? dateDeactivation : null,
			dateRestock: !isNull(dateReappro) ? dateReappro : null,
			restockNow: reapproChoice === 1 ? true : false,
		}

		actionsArticleLifeManager.postScheduledDeactivateAction(
			props.scheduleDeactivateAction.currentState.header.id,
			props.updateMode ? 'editDeactivationAction' : 'scheduleDeactivateAction',
			body,
			scheduledDeactivationState
		)
	}

	// Modal display handling
	const handleChangeDateScheduledDeactivation = (date) => {
		setCurrentDateDeactivation(date)
	}

	// On exiting modal by validation button
	const handleValidateDateScheduledDeactivation = () => {
		setDateDeactivation(currentDateDeactivation)
		setShowScheduledDateModalHandler(false)
	}

	// Modal display handling
	const handleChangeDateReappro = (date) => {
		setCurrentDateReappro(date)
	}

	// On exiting modal by validation button
	const handleValidateDateReappro = () => {
		setDateReappro(currentDateReappro)
		setShowReapproDateModalHandler(false)
		setCanValidate(true)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		const tmp_reappro = moment(dateReappro).unix()
		const tmp_desac = moment(dateDeactivation).unix()

		// If we switched from deactivating now to scheduled deactivation, we must check those two dates,
		// to prevent validation with wrong dates
		if (scheduledDeactivationState && reapproChoice === 2) setCanValidate(tmp_desac <= tmp_reappro)
	}, [dateReappro, dateDeactivation, scheduledDeactivationState, reapproChoice])

	useEffect(() => {
		// If we don't want a reappro date, we unlock validate button
		if (reapproChoice !== 2) {
			// Reset reappro date
			setDateReappro(null)
			// If first choice is made and we are in scheduled mode, we don't want to validate
			if (reapproChoice === 1 && scheduledDeactivationState) {
				// Instead, we set dateReappro === dateDeactivation
				//setCanValidate(false)
				setDateReappro(dateDeactivation)
				//handleChangeDateReappro(dateDeactivation)
				setCanValidate(true)
			} else if (reapproChoice > 0) {
				// But validating button
				setCanValidate(true)
			}
		} else {
			if (isNull(dateReappro)) setCanValidate(false)
			// If current date reappro isn't set (by changing deactivation mode, or by first call)
			if (isNull(currentDateReappro)) {
				if (scheduledDeactivationState) {
					setCurrentDateReappro(dateDeactivation)
				} else {
					// erreur sur le format de la date, il faut que tu verifies les autres lignes corrigées en faisant un +1 et préférer la solution add
					//setCurrentDateReappro(new Date() + 1)
					setCurrentDateReappro(moment(new Date()).add(2, 'days').toDate())
				}
			}
		}
		if (reapproChoice === 0) setCanValidate(false)
	}, [reapproChoice])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.scheduleDeactivateAction.close()
	}, [articleLifeManager?.isUpdate])

	// On loading edit modal
	useEffect(() => {
		if (props.updateMode && props.scheduleDeactivateAction.show) {
			setCurrentDateDeactivation(moment(props.scheduleDeactivateAction?.item?.dateScheduledDeactivation).add(1, 'days').toDate())
			setDateDeactivation(moment(props.scheduleDeactivateAction?.item?.dateScheduledDeactivation).toDate())
			if (!isNull(props.scheduleDeactivateAction?.item?.dateScheduledRestock)) {
				setCurrentDateReappro(moment(props.scheduleDeactivateAction?.item?.dateScheduledRestock).toDate())
				setDateReappro(moment(props.scheduleDeactivateAction?.item?.dateScheduledRestock).toDate())
				if (props.scheduleDeactivateAction?.item?.dateScheduledRestock == props.scheduleDeactivateAction?.item?.dateScheduledDeactivation) {
					setReapproChoice(1)
				} else {
					setReapproChoice(2)
				}
			} else {
				setReapproChoice(3)
			}
		}
		setCanValidate(true)
	}, [props.updateMode, props.scheduleDeactivateAction.show])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModifyScheduleDeactivateActionWrapper>
			<Modals
				showModal={props.scheduleDeactivateAction.show}
				closeModalHandler={props.scheduleDeactivateAction.close}
				title={translations['modal__itemRef__timeline_action_deactivation_progressive_add_title']}
				width={634}
				icon={true}
			>
				{translations && !isEqual(props.scheduleDeactivateAction.currentState?.header, {}) && (
					<Fragment>
						<ArticleDatePicker
							showModal={showScheduledDateModalHandler}
							date={currentDateDeactivation}
							handleValidate={() => handleValidateDateScheduledDeactivation()}
							handleClose={() => setShowScheduledDateModalHandler(false)}
							handleChangeDate={handleChangeDateScheduledDeactivation}
							title={translations['modal__itemRef__timeline_action_deactivation_progressive_add_datePicker_title']}
							insideModal={true}
							priorLimit={moment(new Date()).add(1, 'days').toDate()}
						/>
						<ArticleDatePicker
							showModal={showReapproDateModalHandler}
							date={currentDateReappro}
							handleValidate={() => handleValidateDateReappro()}
							handleClose={() => setShowReapproDateModalHandler(false)}
							handleChangeDate={handleChangeDateReappro}
							title={translations['modal__itemRef__timeline_action_restock_startDate_add_title']}
							insideModal={true}
							priorLimit={!scheduledDeactivationState ? moment(new Date()).add(2, 'days').toDate() : dateDeactivation}
						/>
						<TextTopWrapper>
							<b>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_message_firstPart']}</b>
							<ModalScheduleDeactivateActionCheckboxWrapper>
								<div>
									<input
										type="checkbox"
										checked={!scheduledDeactivationState}
										defaultChecked
										onClick={() => {
											setScheduledDeactivationState(false)
										}}
									/>
									<p>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_message_firstAction']}</p>
								</div>
								<div>
									<input type="checkbox" checked={scheduledDeactivationState} onClick={() => setScheduledDeactivationState(true)} />
									<p>
										{translations['modal__itemRef__timeline_action_deactivation_progressive_add_message_secondAction']}
										<SpanDateDeactivation>
											{!isNull(dateDeactivation)
												? moment(dateDeactivation).format('DD/MM/YYYY')
												: moment().format('DD/MM/YYYY')}
										</SpanDateDeactivation>
									</p>

									{scheduledDeactivationState && (
										<CalendarInputInline noDisplayValue onClickHandler={() => setShowScheduledDateModalHandler(true)} />
									)}
								</div>
							</ModalScheduleDeactivateActionCheckboxWrapper>
							{scheduledDeactivationState ? (
								<Fragment>
									<p
										dangerouslySetInnerHTML={{
											__html: StringFormatter.ResponseMessageParser(
												translations[
													'modal__itemRef__timeline_action_deactivation_progressive_add_message_secondPart_withDate'
												],
												[
													`<span style="color:${theme.colors.primary};">[${props?.scheduleDeactivateAction?.currentState?.header?.itemRefLabel}]</span>`,
													`<span style="color:${theme.colors.primary};">${moment(
														isNull(dateDeactivation) ? currentDateDeactivation : dateDeactivation
													).format('DD/MM/YYYY')}</span>`,
												]
											),
										}}
									></p>
									<b>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_message_thirdPart_withDate']}</b>
								</Fragment>
							) : (
								<Fragment>
									<p
										dangerouslySetInnerHTML={{
											__html: StringFormatter.ResponseMessageParser(
												translations[
													'modal__itemRef__timeline_action_deactivation_progressive_add_message_secondPart_noDate'
												],
												[
													`<span style="color:${theme.colors.primary};">[${props?.scheduleDeactivateAction?.currentState?.header?.itemRefLabel}]</span>`,
												]
											),
										}}
									></p>
									<b>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_message_thirdPart_noDate']}</b>
								</Fragment>
							)}
							{(!scheduledDeactivationState || (scheduledDeactivationState && !isNull(dateDeactivation))) && (
								<ModalScheduleDeactivateActionRadioWrapper>
									<div>
										<input
											type="radio"
											name="reapproChoiceRadio"
											checked={reapproChoice == 1 ? true : false}
											onClick={() => setReapproChoice(1)}
										/>
										<ModalScheduleDeactivateActionRadioText>
											<p>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_radio_first_message']}</p>
											<p>
												<i>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_radio_first_info']}</i>
											</p>
										</ModalScheduleDeactivateActionRadioText>
									</div>
									<ModalScheduleDeactivateActionReapproWrapper>
										<input
											type="radio"
											name="reapproChoiceRadio"
											checked={reapproChoice == 2 ? true : false}
											onClick={() => setReapproChoice(2)}
										/>
										<div>
											<div>
												<p>
													{
														translations[
															'modal__itemRef__timeline_action_deactivation_progressive_add_radio_second_message'
														]
													}{' '}
													:
												</p>
												{!isNull(dateReappro) && reapproChoice === 2 && (
													<p
														dangerouslySetInnerHTML={{
															__html: `<span style="color:${theme.colors.primary};">${moment(dateReappro).format(
																'DD/MM/YYYY'
															)}</span>`,
														}}
													></p>
												)}
												<CalendarInputInline
													noDisplayValue
													disabled={reapproChoice !== 2}
													onClickHandler={() => setShowReapproDateModalHandler(true)}
												/>
											</div>
											{!isNull(dateReappro) && (
												<p className="p_resultDateReappro">
													<i>
														{
															translations[
																'modal__itemRef__timeline_action_deactivation_progressive_add_radio_second_info'
															]
														}
													</i>
												</p>
											)}
										</div>
									</ModalScheduleDeactivateActionReapproWrapper>
									<div>
										<input
											type="radio"
											name="reapproChoiceRadio"
											checked={reapproChoice == 3 ? true : false}
											onClick={() => setReapproChoice(3)}
										/>
										<ModalScheduleDeactivateActionRadioText>
											<p>{translations['modal__itemRef__timeline_action_deactivation_progressive_add_radio_third_message']}</p>
											<p>
												<i>
													{
														translations[
															'modal__itemRef__timeline_action_deactivation_progressive_add_radio_third_info_firstLine'
														]
													}
												</i>
											</p>
											<p>
												<i style={{ color: theme.colors.error }}>
													{
														translations[
															'modal__itemRef__timeline_action_deactivation_progressive_add_radio_third_info_secondLine'
														]
													}
												</i>
											</p>
										</ModalScheduleDeactivateActionRadioText>
									</div>
								</ModalScheduleDeactivateActionRadioWrapper>
							)}
						</TextTopWrapper>
						<ButtonWrapper>
							<Button
								actionHandler={props.scheduleDeactivateAction.close}
								text={translations['common__text__cancel']}
								bgColor={theme.colors.error}
								margin="true"
								img={Cancel}
							/>
							<Button
								actionHandler={handleScheduleDeactivate}
								text={
									scheduledDeactivationState
										? translations['modal__itemRef__timeline_action_deactivation_progressive_add_buttons_validate_scheduled']
										: translations['modal__itemRef__timeline_action_deactivation_progressive_add_buttons_validate_now']
								}
								bgColor={theme.colors.validation}
								disabled={!canValidate}
								img={canValidate && Validation}
							/>
						</ButtonWrapper>
					</Fragment>
				)}
			</Modals>
		</ModifyScheduleDeactivateActionWrapper>
	)
}

ModifyScheduleDeactivateAction.propTypes = {}

ModifyScheduleDeactivateAction.defaultPropTypes = {}

export default ModifyScheduleDeactivateAction
